import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MeetingRoomReservationStatus } from './types'

export type ReservationAction = 'edit' | 'approve' | 'reject' | 'cancel' | 'viewDetails'

export const ACTIONS_BY_STATUS: Record<MeetingRoomReservationStatus, ReservationAction[]> = {
  pendente: ['edit', 'approve', 'reject', 'cancel'],
  aprovada: ['cancel'],
  reprovada: ['viewDetails'],
  cancelada: ['viewDetails'],
}

export const ACTION_CONFIG: Record<
  ReservationAction,
  {
    variant: 'edit' | 'approve' | 'reject' | 'cancel'
    icon: IconProp
    labelKey: string
  }
> = {
  edit: {
    variant: 'edit',
    icon: ['fas', 'pen'],
    labelKey: 'meetingRoom.reservations.action.edit',
  },
  approve: {
    variant: 'approve',
    icon: ['fas', 'check'],
    labelKey: 'meetingRoom.reservations.action.approve',
  },
  reject: {
    variant: 'reject',
    icon: ['fas', 'xmark'],
    labelKey: 'meetingRoom.reservations.action.reject',
  },
  cancel: {
    variant: 'cancel',
    icon: ['fas', 'ban'],
    labelKey: 'meetingRoom.reservations.action.cancel',
  },
  viewDetails: {
    variant: 'edit',
    icon: ['fas', 'eye'],
    labelKey: 'meetingRoom.reservations.action.viewDetails',
  },
}
